import { ActivatedRoute } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { commonService } from '@bl-src/app/core/services/common.service';
import { PlansService } from '@bl-src/app/core/services/plans.service';
import { SharedService } from '@s-app/common/services/shared.service';
import { Feature, PackageFeature, PackagePlan, PriceCycle, SubscriptionDetails } from '@s-app/plans/plans';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PaymentMethodDialogCloseData, PaymentMethodDialogComponent, PaymentMethodDialogData } from './payment-method-dialog/payment-method-dialog.component';
import { ButtonModule } from 'primeng/button';
import { Location } from '@angular/common';
import { SupscribePageLoadingComponent } from './supscribe-page-loading/supscribe-page-loading.component';
import { Change } from '@s-app/subscriptions/buy-plan/change.model';

@Component({
  selector: 'app-subscribe-page',
  standalone: true,
  imports: [CommonModule, TooltipModule, TranslateModule, ButtonModule, SupscribePageLoadingComponent, ConfirmDialogModule],
  providers: [DialogService, DynamicDialogRef, ConfirmationService],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './subscribe-page.component.html',
  styleUrl: './subscribe-page.component.scss'
})
export class SubscribePageComponent {
  planCycles: PriceCycle;
  plans: PackageFeature[];
  selectedPlan: PackageFeature;
  currentPlan: PackageFeature;
  subscriptionDetails: SubscriptionDetails;
  ref: DynamicDialogRef | undefined;
  isLoading: boolean = false;


  constructor(
    public plansService: PlansService,
    public commonService: commonService,
    public shared: SharedService,
    private dialogService: DialogService,
    public readonly location: Location,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
  ) {

  }

  ngOnInit(): void {
    const subscriptionId = Number(this.route.snapshot.paramMap.get('id'))
    this.handleGetSubscriptionsDetails(subscriptionId)
    this.handleGetPlans();
  }

  handleGetPlans(): void {
    this.isLoading = true;
    this.plansService.getPlans().subscribe((res: PackagePlan) => {
      this.plans = res.packageFeatures;
      this.initializePlans();
      setTimeout(() => { this.isLoading = false; }, 1000);
    },
      (error) => {
        this.isLoading = false;
      }
    );
  }
  handleGetSubscriptionsDetails(id: number): void {
    this.plansService.getSubscriptionsDetails(id).subscribe((res: SubscriptionDetails) => {
      this.subscriptionDetails = res;
      this.initializePlans();
    });
  }
  
  private initializePlans(): void {
    if (this.subscriptionDetails && this.plans && this.plans.length > 0) {
      this.currentPlan = this.plans.find((plan: PackageFeature) => plan.planId == this.subscriptionDetails.planId) as PackageFeature;
      if (this.currentPlan) {
        this.selectedPlan = this.currentPlan;
      }
    }
  }

  onPlanSelect(plan: PackageFeature): void {
    this.selectedPlan = plan;
  }

  handleCheckSubscriptionChange(plan: PriceCycle) {
    if (!this.subscriptionDetails) return;
    const changeCheckModel = {
      branchId: this.subscriptionDetails.branch.branchId,
      subscriptionPlanPriceId: plan.planPriceId,
      cycle: plan.cycle,
    };
    this.plansService.checkSubscriptionChange(changeCheckModel).subscribe((res: Change) => {
      if (res.isUpgrade == 2) {
        this.openPaymentMethodDialog(res, plan)
      } else if (res.isUpgrade == 1) {
        // this.handleDowngradePlan(plan)
      }
      console.log('CheckSubscriptionChange response:', res);
    },
      (error) => {
        console.error('CheckSubscriptionChange error:', error);
      }
    );
  }

  getPlanCycles(selectedPlan: PackageFeature): PriceCycle[] {
    if (!selectedPlan) return [];
    const cycles = Object.keys(selectedPlan)
      .filter(key => key.includes('cycle'))
      .map(key => selectedPlan[key as keyof PackageFeature] as PriceCycle)
      .filter(cycle => cycle !== null && cycle !== undefined);
    return cycles;
  }
  openPaymentMethodDialog(data: Change, plan: PriceCycle): void {
    if (!this.subscriptionDetails || !this.selectedPlan) return;
    const header = localStorage.getItem('lang') === 'ar' ? 'اختر طريقة الدفع' : 'Select payment method';
    const title = localStorage.getItem('lang') === 'ar' ? 'ترقية الخطة إلى' : 'Upgrade plan to';
    this.ref = this.dialogService.open(PaymentMethodDialogComponent, {
      header: header,
      width: '35vw',
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      },
      data: {
        title: `${title} ${this.selectedPlan.name}`,
        price: data.payment.cost,
        currency: data.payment.currency,
      } as PaymentMethodDialogData,
      contentStyle: { overflow: 'auto' },
      closeOnEscape: false,
      closable: false,
      styleClass: 'custom-dialog-style',
    });
    this.ref.onClose.subscribe((res: PaymentMethodDialogCloseData) => {
      if (res) {
        this.shared.isLoading = true;
        const subscriptionData = {
          paymentMethodEnum: res.PaymentMethodEnum,
          branchId: this.subscriptionDetails.branch.branchId,
          subscriptionPlanPriceId: plan.planPriceId,
          cycle: plan.cycle,
          renewalOptions: 1,
          licenseId: this.subscriptionDetails.licenseId,
        };
        console.log(subscriptionData);
        this.handleUpgradePlan(subscriptionData)
      }
    });
  }


  compareFeatures() {
    if (!this.currentPlan || !this.selectedPlan) return [];
    const lostFeatures = this.currentPlan.features.filter(currentFeature => {
      const selectedFeature = this.selectedPlan.features.find(feature => feature.name === currentFeature.name);
      return currentFeature.isExist && (!selectedFeature || !selectedFeature.isExist);
    }).map(feature => ({
        nameEn: feature.nameEn,
        nameAr: feature.nameAr
      }));
    return lostFeatures;
  }

  handleDowngradePlan(plan: PriceCycle): void {
    if (!this.subscriptionDetails || !this.currentPlan || !this.selectedPlan) return;
    const lostFeaturesMessage = this.compareFeatures().map(feature => this.commonService.getLang() === 'ar' ? `- ${feature.nameAr}` : `- ${feature.nameEn}`).join("<br>")
    const msgAr = `أنت على وشك الانتقال من ${this.currentPlan.name} إلى  ${this.selectedPlan.name}. عند تأكيد هذا الإجراء، ستفقد إمكانية الوصول إلى الميزات الحصرية التالية ضمن ${this.currentPlan.name}:<br>${lostFeaturesMessage}`;
    const msgEn = `You are about to switch from the ${this.currentPlan.name} Plan to the ${this.selectedPlan.name} Plan. By proceeding, you will lose access to the following  ${this.currentPlan.name}-only features:<br>${lostFeaturesMessage}`;
    this.confirmationService.confirm({
      message: this.commonService.getLang() === 'ar' ? msgAr : msgEn,
      header: this.commonService.getLang() === 'ar' ? 'تحذير' : 'Downgrade Notice',
      acceptIcon: "none",
      rejectIcon: "none",
      acceptLabel: this.commonService.getLang() === 'ar' ? 'تأكيد' : 'Confirm',
      rejectLabel: this.commonService.getLang() === 'ar' ? 'الغاء' : 'Cancel',
      acceptButtonStyleClass: "border-1 border-solid border-[#6938EF] text-[#6938EF] py-[8px] px-[16px] rounded-[8px]",
      rejectButtonStyleClass: "border-1 border-solid border-[#535353] text-[#535353] py-[8px] px-[16px] rounded-[8px] me-2",
      accept: () => {
        const subscriptionData = {
          branchId: this.subscriptionDetails.branch.branchId,
          subscriptionPlanPriceId: plan.planPriceId,
          cycle: plan.cycle,
          renewalOptions: 1,
          licenseId: this.subscriptionDetails.licenseId,
        };
        console.log(subscriptionData);
        this.handleUpgradePlan(subscriptionData);

      },
      reject: () => { }
    });
  }

  private handleUpgradePlan(subscriptionData: { paymentMethodEnum?: number, branchId: number, subscriptionPlanPriceId: number, cycle: number, renewalOptions: number, licenseId: number }): void {
    this.plansService.upgradeSubscription(subscriptionData).subscribe(
      (response) => {
        console.log('Payment successful:', response);
        if (response.paymentProviderURL && response.upgradeType == 2) {
          this.shared.isLoading = false;
          window.location.href = response.paymentProviderURL;
        } else {
          window.location.href = '/subscription';
        }
      },
      (error) => {
        console.error('Subscription error:', error);
      }
    );
  }


}
